import axios from 'axios';
export default {
    baseURL_API: 'https://auth.softtouch.eu/login.php?route=',
    baseURL_shopping: 'https://shopping.softtouch.eu/',
    baseURL_office: 'https://office.softtouch.eu/',
    baseURL_files: 'https://my.softtouch.eu/files/',
    baseURL_node: 'https://queuetest.softtouch.eu/',
    baseURL_auth: 'https://auth.softtouch.eu/',
    baseURL_SFT_API: 'https://api-sft.softtouch.eu/',
    baseURL_MAIL_API: 'https://mail-integrations.softtouch.eu/',
    baseURL_PEPPOL_API: 'https://peppol.softtouch.eu/',
    // Google OAuth Configuration
    // Note: Replace with your actual Google Client ID
    google_client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID || '910885826930-0ni6jums6sqn1cvqk6dbqfek16il3qg4.apps.googleusercontent.com',
    // Apple OAuth Configuration
    // Note: Replace with your actual Apple Service ID
    apple_client_id: process.env.REACT_APP_APPLE_CLIENT_ID || 'eu.softtouch.mysofttouch.service',
    debug: false,
    isSuperUser: false,
    //baseURL_V2: 'https://api-sft.softtouch.eu/2/accounts/',
    version: 'V3.26.16.2',
    appName: 'MySoftTouch',
    website: 'www.softtouch.eu',
    email: 'support@softtouch.be',
    phone: '+32 (0)9 219 00 83',
    easter1: false,
    easter2: false,
    easter3: false,
    dateObjFormatter: (date) => {
        let localDate = date;
        const options = { year: 'numeric', month: 'numeric', day: 'numeric' };
        return localDate.toLocaleString('fr-BE', options);
    },
    dateFormatter: (date) => {
        let localDate = new Date(date);
        const options = { year: 'numeric', month: 'numeric', day: 'numeric' };
        return localDate.toLocaleString('fr-BE', options);
    },
    dateTimeFormatter: (dateTime) => {
        let localDateTime = new Date(dateTime);
        const options = { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' };
        return localDateTime.toLocaleString('fr-BE', options);
    },
    escapeText: (string) => {
        const replacements = {
            "'": "\\'",
            '"': '\\"',
            '\\': '\\\\',
            '\n': '\\n',
            '\r': '\\r',
            '\t': '\\t',
            '\b': '\\b',
            '\f': '\\f',
        };
        return string.replace(/['"\\\n\r\t\b\f]/g, (char) => replacements[char]);
    },
    vlChecker: (sft) => {
        return (sft == "1" || sft == "2");
    },
    wallChecker: (sft) => {
        return (sft == "1" || sft == "3");
    },
    validationTest: (data, validationString) => {
        if(data === undefined)
            return false;

        if (validationString.test(data))
        {
            return true;
        } else {
            return false;
        }
    },
    confirmWindow: (question) => {
        let confirmAction = window.confirm(question);
        return confirmAction;
    },
    peppol_password: "0jEeuwuVsTxHR4n1ypfyNrInunL@Oxtf$fJQ",
    ai_password: "CtfjT9ff1bh6hkUolA2P2uCmTehih1ff7R6G",
    superUltraSecretLockPassword: "DitIsBertZijnWachtwoordVoor2024!",
    noimage: "data:image/bmp;base64,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",
    colors: [
        '#2196f3', 
        '#800000', 
        '#bfef45', 
        '#808000', 
        '#469990', 
        '#000075', 
        '#e6194B', 
        '#f58231', 
        '#ffe119', 
        '#aaffc3', 
        '#3cb44b', 
        '#42d4f4', 
        '#4363d8', 
        '#9A6324', 
        '#911eb4', 
        '#f032e6', 
        '#a9a9a9', 
        '#fabed4', 
        '#ffd8b1', 
        '#fffac8',
        // Repeat
        '#2196f3', 
        '#800000', 
        '#bfef45', 
        '#808000', 
        '#469990', 
        '#000075', 
        '#e6194B', 
        '#f58231', 
        '#ffe119', 
        '#aaffc3', 
        '#3cb44b', 
        '#42d4f4', 
        '#4363d8', 
        '#9A6324', 
        '#911eb4', 
        '#f032e6', 
        '#a9a9a9', 
        '#fabed4', 
        '#ffd8b1', 
        '#fffac8',
        // Repeat
        '#2196f3', 
        '#800000', 
        '#bfef45', 
        '#808000', 
        '#469990', 
        '#000075', 
        '#e6194B', 
        '#f58231', 
        '#ffe119', 
        '#aaffc3', 
        '#3cb44b', 
        '#42d4f4', 
        '#4363d8', 
        '#9A6324', 
        '#911eb4', 
        '#f032e6', 
        '#a9a9a9', 
        '#fabed4', 
        '#ffd8b1', 
        '#fffac8'
    ],
    defaultKey: "A3EEBABC4ABD6A48B9612EC4D6917F7238334AFCB64EA4E1F72F8F377FA6B85E7C77076D6DB8F1A3A124C9910741382D690B0DBB7B0B0A944CABBB16B540B5804971510CCE2AA2CA6227FD93690B00E9AB5C51C236CACB19E94F4ECB6717AFEDCFEBD24D387E3A31726AAFB84E2577BC4155E2D48A443FABE88C034CA52FC6EAF405E8C7901F23CF85A1294FC9C1C2DB272BD4821F80E376C9D38B9B9D7B26102EB0EAA2BF083002338CFE5C81CBDA38072B93C170A6CE15FA4E44F87C088AF0809CDE0271BBE3A4FA55E7D5A0F4AE0338B508A63301B98E51C588D802F7904F",
    // Generalized POST request
    post: async function(endpoint, data, options = {}) {
        // Build URL with dev parameter if debug is enabled
        let url = this.baseURL_API + endpoint;
        const urlParams = new URLSearchParams(url.split('?')[1] || '');
        
        // Add dev parameter if debug is enabled or user is SUPER
        if ((this.debug || this.isSuperUser) && !urlParams.has('dev')) {
            url += (url.includes('?') ? '&' : '?') + 'dev=true';
        }
        
        // Default headers
        const defaultHeaders = {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        };
        
        // Merge options
        const config = {
            headers: { ...defaultHeaders, ...(options.headers || {}) },
            // Allow axios to handle 4xx responses without throwing
            validateStatus: function (status) {
                // Consider any status code less than 500 as a valid response
                return status < 500;
            },
            ...options
        };
        
        // Log request info in debug mode
        if (this.debug) {
            console.log('POST Request:', {
                url,
                data,
                config
            });
        }
        
        try {
            const response = await axios.post(url, data, config);
            
            // Handle success response (200)
            if (response.status === 200) {
                if (this.debug) {
                    console.log('POST Response Success for ' + endpoint + ':', response);
                    if (response.data?.dev) {
                        console.log('Dev Info:', response.data.dev);
                    }
                }
                
                // Build success response
                const successResponse = {
                    success: true,
                    status: response.status,
                    message: response.data.message || 'Request successful',
                    translation_key: response.data.translation_key,
                    data: response.data.data || null
                };
                
                // Only add dev field if debug is true and dev data exists
                if (this.debug && response.data.dev) {
                    successResponse.dev = response.data.dev;
                }
                
                return successResponse;
            }
            
            // Handle error response (400)
            if (response.status === 400) {
                if (this.debug) {
                    console.error('POST Error Response (400) for ' + endpoint + ':', response);
                    if (response.data?.dev) {
                        console.error('Dev Info:', response.data.dev);
                    }
                }

                // Build error response
                const errorResponse = {
                    success: false,
                    status: response.status,
                    message: response.data.message || 'Bad request',
                    translation_key: response.data.translation_key,
                    error: 'Bad Request',
                    data: response.data.data || null  // <-- Add this line
                };

                // Only add dev field if debug is true and dev data exists
                if (this.debug && response.data.dev) {
                    errorResponse.dev = response.data.dev;
                }

                return errorResponse;
            }
            
            // Handle other status codes (401, 403, 404, etc.)
            if (this.debug) {
                console.warn(`Unexpected status code: ${response.status}`, response);
            }
            
            const otherResponse = {
                success: false,
                status: response.status,
                message: response.data?.message || response.statusText,
                translation_key: response.data?.translation_key,
                error: response.statusText,
                data: response.data
            };
            
            // Only add dev field if debug is true and dev data exists
            if (this.debug && response.data?.dev) {
                otherResponse.dev = response.data.dev;
            }
            
            return otherResponse;
            
        } catch (error) {
            // Now this catch block will only handle network errors, timeouts, 
            // and 5xx server errors (since we set validateStatus to accept < 500)
            
            if (this.debug) {
                console.error('POST Network/Setup Error:', error);
            }
            
            // Handle 5xx server errors
            if (error.response && error.response.status >= 500) {
                const serverErrorResponse = {
                    success: false,
                    status: error.response.status,
                    message: error.response.data?.message || 'Server error',
                    translation_key: error.response.data?.translation_key || 'error_server',
                    error: error.response.statusText || 'Internal Server Error'
                };
                
                if (this.debug && error.response.data?.dev) {
                    serverErrorResponse.dev = error.response.data.dev;
                }
                
                return serverErrorResponse;
            }
            
            // Handle timeout errors
            if (error.code === 'ECONNABORTED') {
                return {
                    success: false,
                    status: 0,
                    error: 'Request Timeout',
                    message: 'The request took too long to complete',
                    translation_key: 'error_timeout'
                };
            }
            
            // Handle network errors
            if (error.code === 'ERR_NETWORK') {
                return {
                    success: false,
                    status: 0,
                    error: 'Network Error',
                    message: 'Unable to connect to the server',
                    translation_key: 'error_network'
                };
            }
            
            // Generic error
            return {
                success: false,
                status: 0,
                error: 'Request Failed',
                message: error.message || 'An unexpected error occurred',
                translation_key: 'error_generic',
                details: error
            };
        }
    },
    // Generalized GET request
    get: async function(endpoint, params = {}, options = {}) {
        // Build URL with parameters
        const urlParams = new URLSearchParams(params);
        if (this.debug) {
            urlParams.append('dev', 'true');
        }
        
        let url = this.baseURL_API + endpoint;
        const paramString = urlParams.toString();
        if (paramString) {
            url += '&' + paramString;
        }
        
        // Log request info in debug mode
        if (this.debug) {
            console.log('GET Request:', {
                url,
                params,
                options
            });
        }
        
        // Make the request and handle debug response
        try {
            const response = await axios.get(url, options);
            if (this.debug) {
                console.log('GET Response:', response);
                if (response.data?.dev) {
                    console.log('Dev Info:', response.data.dev);
                }
            }
            return response;
        } catch (error) {
            if (this.debug) {
                console.error('GET Error:', error);
            }
            throw error; // Re-throw to handle in component
        }
    }
}